import { Chip } from '@mui/material';
import React from 'react';

interface EventChipProps {
  icon: any;
  label: string;
  color?: any;
  deleteIcon?: any;
}

export const EventChip = (props: EventChipProps) => {
  const { icon, label, color, deleteIcon } = props;

  return <Chip color={color} icon={icon} label={label} deleteIcon={deleteIcon} variant="outlined" />;
};
